package com.milta.feature.auth.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class OAuthAuthenticateResponse(
    val isRegistered: Boolean,
    val phoneVerified: Boolean,
    val phoneNumber: String? = null,
    val auth: TokenResponse? = null,
)
